import React from 'react';
import { Box, LinearProgress, Typography } from '@mui/material';

// UsageBanner shows record usage progress.
// When the limit is hit, the existing Stripe buy buttons in GeneratePatients handle the upgrade flow.
const UsageBanner = ({ used, limit }) => {
  const safeUsed = used ?? 0;
  const safeLimit = limit ?? 20;
  const remaining = Math.max(0, safeLimit - safeUsed);
  const pct = safeLimit > 0 ? Math.min(100, (safeUsed / safeLimit) * 100) : 100;

  const progressColor = remaining === 0 ? 'error' : remaining < 5 ? 'warning' : 'success';

  return (
    <Box sx={{ mb: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.5 }}>
        <Typography variant="body2" color="text.secondary">
          {remaining === 0
            ? 'You have used all your free records — upgrade below to generate more.'
            : `You have ${remaining} of ${safeLimit} free records remaining`}
        </Typography>
      </Box>
      <LinearProgress
        variant="determinate"
        value={pct}
        color={progressColor}
        sx={{ height: 6, borderRadius: 3 }}
      />
    </Box>
  );
};

export default UsageBanner;
